<template>
    <CompassModal
        ref="AICancelDialog"
        v-model:visible="showModal"
        class="ai-cancel-dialog"
        size="small"
        :title="$t.__('richtext.AICancelModal.cancel_generated_content')"
        :primaryAction="{
            label: $t.__('richtext.AICancelModal.confirm_and_reestablish'),
            action: handleConfirm,
        }"
        :secondaryActions="[
            {
                label: $t.__('richtext.AICancelModal.back'),
                action: () => {
                    showModal = false;
                },
            },
        ]"
        @closed="$emit('close')"
    >
        <template #default>
            <p
                class="typographies-paragraph-medium-regular"
                v-html="$t.__('richtext.AICancelModal.description', { br: '<br />' })"
            />
        </template>
    </CompassModal>
</template>

<script>
export default {
    props: {
        hash: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            showModal: false,
        };
    },
    mounted() {
        this.showModal = true;
    },
    methods: {
        handleConfirm() {
            this.$store.dispatch(
                `${this.hash}/setCancelAIGeneration`,
                !this.$store.state[this.hash].cancelAIGeneration,
            );
            this.showModal = false;
        },
    },
};
</script>
<style lang="scss" scoped>
.ai-cancel-dialog {
    p {
        margin: 0;
    }
}
</style>
